import * as m from "@/paraglide/messages"
import { isSystemPopupOpen, showSystemPopup } from "@/shared/lib/platform"
import { openExternalLink } from "@/shared/lib/telegram"

const SUPPORT_LINK = "https://t.me/lunisupport"

export async function showIdentityRejectedPopup(): Promise<void> {
	if (isSystemPopupOpen()) return

	const buttonId = await showSystemPopup({
		title: m.authResolveFailedTitle(),
		message: m.authResolveFailedMessage(),
		buttons: [
			{ id: "cancel", type: "cancel", text: m.authResolveFailedClose() },
			{ id: "support", text: m.authResolveFailedSupport() },
		],
	})
	if (buttonId === "support") {
		openExternalLink(SUPPORT_LINK)
	}
}
